import { getBackgroundPositionByFocusPoint } from "../helpers/helpers";
import React from "react";
import { createUseStyles } from "react-jss";
import { BackgroundImage } from "./BackgroundImage";
import { BackgroundVideo } from "./BackgroundVideo";
import { ImageOutlined } from "@mui/icons-material";
import { useScrollytellTranslation } from "../Admin/scrollytellContext";

const useStyles = createUseStyles({
  background: {
    position: "absolute",
    width: "100%",
    height: "100%",
    zIndex: 1,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    transition: "opacity 400ms ease-in-out",
    opacity: 0,
    "&.active": {
      opacity: "1 !important",
    },
    backgroundPositionX: ({ backgroundPositionX }) => backgroundPositionX + "%",
    backgroundPositionY: ({ backgroundPositionY }) => backgroundPositionY + "%",
  },
  emptyPlaceholder: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    backgroundColor: "#1E293B",
    color: "#94A3B8",
    fontSize: "14px",
    gap: "8px",
  },
});

export const OneOfMultiBackgrounds = ({
  background,
  gradient,
  active,
  opacity,
  priority = false,
  isAdminMode = false,
}) => {
  const t = useScrollytellTranslation();
  const { backgroundPositionX, backgroundPositionY } =
    getBackgroundPositionByFocusPoint(background?.x, background?.y);

  const classes = useStyles({
    backgroundPositionX,
    backgroundPositionY,
    gradient,
  });

  const backgroundImage = background?.image;
  const backgroundVideo = background?.video;
  const hasMedia = Boolean(backgroundImage || backgroundVideo);

  return (
    <div
      className={`${classes.background} ${active ? "active" : ""}`}
      style={{
        opacity,
        backgroundSize: !hasMedia ? "auto" : undefined,
        backgroundRepeat: !hasMedia ? "repeat" : undefined,
      }}
    >
      {backgroundVideo ? (
        <BackgroundVideo
          videoUrl={backgroundVideo}
          active={active}
          gradient={gradient}
        />
      ) : backgroundImage ? (
        <BackgroundImage
          backgroundImage={backgroundImage}
          positionX={backgroundPositionX}
          positionY={backgroundPositionY}
          gradient={gradient}
          priority={priority}
          active={active}
        />
      ) : !hasMedia && isAdminMode ? (
        <div className={classes.emptyPlaceholder}>
          <ImageOutlined sx={{ fontSize: 40 }} />
          <span>
            {t(
              "oneOfMultiBackgrounds.emptyPlaceholder",
              "Ingen bakgrunn valgt for dette steget"
            )}
          </span>
        </div>
      ) : null}
    </div>
  );
};
